var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 650,
    viewBox: "0 0 650 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.059 391.049L321.107 75.7314L325.049 68.9053L328.99 75.7314L431.761 253.736L431.762 253.736L511.02 391.05L512.332 393.325L511.019 395.6L408.235 573.627L404.293 580.454L400.353 573.627L325.049 443.165L249.745 573.627L245.805 580.454L241.862 573.627L139.059 395.601L137.745 393.325L139.059 391.049Z",
    stroke: "url(#paint0_linear_8150_383)",
    strokeWidth: 9.10194
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.93 392.95L247.953 259.541L402.001 259.541L479.025 392.95L402.001 526.359L324.977 392.95L247.953 526.359L170.93 392.95Z",
    fill: "#374550"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M325.194 126.008L260.82 237.507L389.568 237.507L325.194 126.008Z",
    fill: "#FF6600"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8150_383",
    x1: 325.048,
    y1: 69.497,
    x2: 325.048,
    y2: 584.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#374550"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.6ceef51906debf3048935a16cb54a429.svg";
export { ForwardRef as ReactComponent };